import React from "react";

import { IProgressMetric } from "@Components/activity/hooks/useAssociatedStatuses";
import { Col, Row, Typography } from "antd";
import RingProgressPieChart from "@Components/shared/RingProgressPieChart";

const { Title } = Typography;

interface IProps {
    progress: IProgressMetric;
}

const CMEChart = ({ progress }: IProps) => {
    return (
        <Row>
            <Col xs={24}>
                <Title level={3} style={{ width: "100%" }}>
                    CME Points
                </Title>
                <span style={{ marginBottom: "30px", display: "block" }}>
                    1 Point Awarded for each completed questionnaire
                </span>
            </Col>
            <Col xs={24}>
                <RingProgressPieChart progress={progress} />
            </Col>
        </Row>
    );
};

export default CMEChart;
